import VueClipboard from 'vue-clipboard2'
import * as echarts from 'echarts'
import ECharts from 'vue-echarts'
import directives from './directives'
import * as filters from './filters'
// 导入连线画图工具
import jsPlumb from 'jsplumb'
import htmlToPdf from '@/utils/modules/htmlToPdf.js'
import vueTouch from './vueTouch'

VueClipboard.config.autoSetContainer = true
export default {
  install (Vue) {
    Vue.use(htmlToPdf)

    Vue.prototype.$echarts = echarts
    Vue.prototype.$jsPlumb = jsPlumb.jsPlumb
    Vue.component('VCharts', ECharts)

    // 全局filter
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
    })
    // 全局directive
    Vue.use(directives)
    Vue.use(VueClipboard)
    Vue.use(vueTouch)

    // 格式化表格日期数据
    Vue.prototype.formatterDate = (row, { property, fmt = '' }) => {
      const v = row[property]
      return filters.formatDate(v, fmt)
    }

    //  深复制
    Vue.prototype.clone = function (obj) {
      if (typeof obj !== 'object') return obj
      if (JSON) {
        const str = JSON.stringify(obj)
        return JSON.parse(str)
      }
    }
  }
}
